export const MarkIcon = () => {
  return (
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5.36364L4.57521 9L12.4407 1" stroke="black" strokeWidth="2" />
    </svg>
  );
};
